(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report-material-category', {
            parent: 'entity',
            url: '/patch-report-material-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportMaterialCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-categories.html',
                    controller: 'PatchReportMaterialCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportMaterialCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-material-category-detail', {
            parent: 'entity',
            url: '/patch-report-material-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportMaterialCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-detail.html',
                    controller: 'PatchReportMaterialCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportMaterialCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReportMaterialCategory', function($stateParams, PatchReportMaterialCategory) {
                    return PatchReportMaterialCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report-material-category.new', {
            parent: 'patch-report-material-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-dialog.html',
                    controller: 'PatchReportMaterialCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report-material-category', null, { reload: true });
                }, function() {
                    $state.go('patch-report-material-category');
                });
            }]
        })
        .state('patch-report-material-category.edit', {
            parent: 'patch-report-material-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-dialog.html',
                    controller: 'PatchReportMaterialCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReportMaterialCategory', function(PatchReportMaterialCategory) {
                            return PatchReportMaterialCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-material-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report-material-category.delete', {
            parent: 'patch-report-material-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-material-category/patch-report-material-category-delete-dialog.html',
                    controller: 'PatchReportMaterialCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReportMaterialCategory', function(PatchReportMaterialCategory) {
                            return PatchReportMaterialCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-material-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
